module.exports = __webpack_public_path__ + "assets/shake-glass-1.300666fe.svg";